/**
 * goals.js
 * 
 * API for handling getting goal data
 */

import axiosInstance from "./axios-instance";

/**
 * GET request to return goals for a specific client. (legacy endpoint - from sa_form_responses)
 * @returns 
 */
const retrieveGoals = async function (clientId) {
    return axiosInstance.get(`/app/goals/${clientId}`).then(res => res);
}

// New goal endpoints (staff/admin scope)
const listGoals = async function (params) {
    return axiosInstance.get(`/goals`, { params }).then(res => res);
}

const listGoalTypes = async function () {
    return axiosInstance.get(`/goals/types`).then(res => res);
}

const createGoal = async function (payload) {
    return axiosInstance.post(`/goals`, payload).then(res => res);
}

const updateGoal = async function (id, payload) {
    return axiosInstance.patch(`/goals/${id}`, payload).then(res => res);
}

const deleteGoal = async function (goal_id, client_id) {
    return axiosInstance.delete(`/goals/${goal_id}`, { params: { client_id } }).then(res => res);
}

const engagementGoalsPath = function (personId, engagementId) {
    return `/app/tk-people/${personId}/engagements/${engagementId}/goals`;
}

const listEngagementGoals = async function (personId, engagementId, params = {}) {
    return axiosInstance.get(engagementGoalsPath(personId, engagementId), { params }).then(res => res);
}

const createEngagementGoal = async function (personId, engagementId, payload) {
    return axiosInstance.post(engagementGoalsPath(personId, engagementId), payload).then(res => res);
}

const updateEngagementGoal = async function (personId, engagementId, goalId, payload) {
    return axiosInstance.patch(`${engagementGoalsPath(personId, engagementId)}/${goalId}`, payload).then(res => res);
}

const deleteEngagementGoal = async function (personId, engagementId, goalId) {
    return axiosInstance.delete(`${engagementGoalsPath(personId, engagementId)}/${goalId}`).then(res => res);
}

const invalidateCache = function (clientId) {
    // Invalidate list of goals for specified client ID
    const clientParam = `client_id=${encodeURIComponent(clientId)}`;
    axiosInstance.storage.remove((key) => {
        return key.includes('/goals')
            && (key.includes(`${clientParam}&`) || key.endsWith(clientParam));
    });
}

const invalidateEngagementCache = function (personId, engagementId) {
    const path = engagementGoalsPath(personId, engagementId);
    axiosInstance.storage.remove((key) => key.includes(path));
}

export default {
    retrieveGoals,
    listGoals,
    listGoalTypes,
    createGoal,
    updateGoal,
    deleteGoal,
    invalidateCache,
    listEngagementGoals,
    createEngagementGoal,
    updateEngagementGoal,
    deleteEngagementGoal,
    invalidateEngagementCache
};
